import React from 'react';

import PropTypes from 'prop-types';

import { Wrapper, Body, Author } from './styled';

const BlockQuote = ({ text, author }) => (
  <Wrapper>
    <Body>{text}</Body>

    {author && <Author>{author}</Author>}
  </Wrapper>
);

BlockQuote.propTypes = {
  text: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
};

export default BlockQuote;
